module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "withdraw-details container-fluid"
  }, [_c('withdraw-details-pc', {
    staticClass: "pc-show"
  }), _vm._v(" "), _c('withdraw-details-m', {
    staticClass: "phone-show"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e8d9235!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/withdrawDetails/Index.vue
// module id = 1302
// module chunks = 1